import { atom } from "jotai";
import debounce from "lodash/debounce";

const UPDATE_DELAY = 250;
export const promocodeAtom = atom(
  "",
  debounce((_get, set, code) => {
    set(promocodeAtom, code);
  }, UPDATE_DELAY)
);
export const promocodeInputAtom = atom("", (_get, set, value) => {
  value = value.trim();
  set(promocodeInputAtom, value);
  set(promocodeAtom, value);
});
